import {ChangeEvent, useState} from 'react';
import {toast} from 'react-toastify';
import Button from '../../../../components/button';
import CustomCheckbox from '../../../../components/mazraeKit/customCheckbox';
import MainFooter from '../../../../components/mazraeKit/footers/footerMain';
import SpinnerLoading from '../../../../components/SpinnerLoading';
import downloadPDF from '../../../../global/helpers/downloadPDF';
import useGetListLoanRequest from '../../../../services/hookService/getListLoanRequest/useGetListLoanRequest';
import useGetLoanTypeDetail from '../../../../services/hookService/getLoanTypeDetail/useGetLoanTypeDetail';
import usePostSignLoanContract from '../../../../services/hookService/postSignLoanContract/usePostSignLoanContract';
import {
  LoanRequestStatus,
  showCancelButtonByLoanStatus,
} from '../../../myAccount/my-credits/consts/loanStatus';
import MultiStepComponent from '../MultiStepComponent';
import {receiveCreditSteps} from '../receiveCreditSteps';
import LoanRequestHeader from '../step3-completeDocs/components/LoanRequestHeader';
import {useMultiStepForm} from '../useMultiStepForm';

const SignContractPage = () => {
  const {stepNumber} = useMultiStepForm();

  const [isUserAgreed, setIsUserAgreed] = useState<boolean>(false);
  const [isDownloading, setIsDownloading] = useState(false);

  const {data: listLoanRequest, isLoading: isListLoanRequestLoading} =
    useGetListLoanRequest({
      is_finished: false,
    });
  const navigateToEmzaNo = () => {
    window.location.href =
      'https://app.emzano.com/documents/detail?id=' + listLoanRequest?.guid;
  };

  const {data: loanTypeDetail, isLoading: isLoanTypeDetailLoading} =
    useGetLoanTypeDetail(listLoanRequest?.guid);

  const {mutate: signContract, isLoading: isSigningContractLoading} =
    usePostSignLoanContract({
      loan_request_guid: listLoanRequest?.guid!,
      onSuccess: () => {
        navigateToEmzaNo();
      },
      onError: error => {
        toast.error(error?.response?.data?.message || 'خطایی رخ داده است');
      },
    });

  const isLoading = isListLoanRequestLoading || isLoanTypeDetailLoading;

  const handleNextSection = () => {
    if (listLoanRequest?.status === LoanRequestStatus.DOCUMENT_FILLED)
      signContract();
    if (listLoanRequest?.status === LoanRequestStatus.PENDING_DIGITAL_SIGN)
      navigateToEmzaNo();
  };

  const handleDownloadContract = async () => {
    try {
      setIsDownloading(true);

      await downloadPDF(loanTypeDetail?.contract_pdf_url);
    } catch (error) {
      toast.error('خطا در دانلود قرارداد');
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="flex flex-col w-full bg-white h-dvh">
      {/* Header */}
      <LoanRequestHeader
        backPath="/my-credits"
        title="امضای قرارداد"
        loanRequestGuid={listLoanRequest?.guid}
        showCancelButton={showCancelButtonByLoanStatus(
          listLoanRequest?.status as LoanRequestStatus,
        )}
      />

      {/* Content */}
      <div className="flex flex-col w-full h-full gap-3 p-3 overflow-y-auto">
        {isLoading && (
          <div className="grid h-dvh place-content-center">
            <SpinnerLoading />
          </div>
        )}

        {!isLoading && (
          <>
            <MultiStepComponent
              steps={receiveCreditSteps}
              currentStep={stepNumber}
            />

            <section className="flex flex-col gap-[1.5rem] mt-3 text-sm">
              <div>
                <h6 className="pb-1 text-sm font-medium text-gray-800">
                  قرارداد بین بانک و متقاضی
                </h6>
                <span className="text-gray-600">
                  برای دریافت اعتبار بانکی لازم است قراردادتان را امضا کنید. آن
                  را دانلود کنید، با دقت بخوانید و در صورت درستی اطلاعات امضا
                  کنید.
                </span>
              </div>
              <div className="flex flex-col w-full">
                <Button
                  type="button"
                  variant="outline"
                  isLoading={isDownloading}
                  disabled={isDownloading}
                  onClick={handleDownloadContract}
                >
                  دانلود قرارداد
                </Button>
              </div>
              {listLoanRequest?.status ===
              LoanRequestStatus.PENDING_DIGITAL_SIGN ? (
                <span className="mt-[1rem] text-sm text-gray-700">
                  در انتظار امضای قرارداد توسط ذینفعان
                </span>
              ) : (
                <CustomCheckbox
                  name={'contract-agreement'}
                  customClass="gap-1 mt-2"
                  title="قرارداد را خواندم و شرایط را می‌پذیرم"
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    setIsUserAgreed(e.target.checked)
                  }
                  checked={isUserAgreed}
                />
              )}

              <div className="fixed left-0 right-0 z-50 flex flex-col w-full gap-2 bottom-2 ">
                <div className="p-3">
                  <Button
                    type="button"
                    disabled={
                      listLoanRequest?.status ===
                      LoanRequestStatus.PENDING_DIGITAL_SIGN
                        ? false
                        : !isUserAgreed
                    }
                    isLoading={isSigningContractLoading}
                    onClick={handleNextSection}
                    className="w-full"
                  >
                    امضا قرارداد
                  </Button>
                </div>

                <MainFooter isScrolling={false} />
              </div>
            </section>
          </>
        )}
      </div>
    </div>
  );
};

export default SignContractPage;
